import { __assign, __extends } from "tslib";
import * as React from 'react';
import { namespacedClassnames, isPromise, RISK_BAD_UX_DISABLE_TOOLTIP } from '../../../common';
import { Tooltip } from '../../../primitives/tooltip/tooltip';
import { TinyLoader } from '../../../primitives/loaders/tiny-loader';
export var buttonKey = 'button';
var defaultButtonProps = {
    intent: 'neutral',
    type: 'primary',
    size: 'regular'
};
var isCustomIntent = function (intent) {
    return intent ? !!intent.color && !!intent.hoverColor : false;
};
var Button = /** @class */ (function (_super) {
    __extends(Button, _super);
    function Button() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.elemRef = null;
        _this.unMounted = false;
        _this.state = { loading: false };
        _this.setRef = function (ref) { return _this.elemRef = ref; };
        _this.startLoading = function () {
            var elem = _this.elemRef;
            if (elem && !_this.unMounted) {
                var width = elem.getBoundingClientRect().width || elem.offsetWidth;
                var height = elem.getBoundingClientRect().height || elem.offsetHeight;
                _this.setState({ loading: true, width: width, height: height });
            }
        };
        _this.stopLoading = function () {
            var elem = _this.elemRef;
            if (elem && !_this.unMounted) {
                _this.setState({ loading: false, width: undefined, height: undefined });
            }
        };
        _this.onClick = function (e) {
            var result = _this.props.onClick(e);
            if (result && isPromise(result)) {
                _this.startLoading();
                result.then(_this.stopLoading, _this.stopLoading);
            }
        };
        _this.getStyle = function (intent) {
            var _a = _this.state, loading = _a.loading, width = _a.width, height = _a.height;
            var maybeStyle = loading ? { width: width, height: height } : {};
            var customStyle = isCustomIntent(intent) ? {
                '--color': intent.color,
                '--hover-color': intent.hoverColor
            } : {};
            return __assign(__assign({}, maybeStyle), customStyle);
        };
        return _this;
    }
    Button.prototype.componentWillUnmount = function () { this.unMounted = true; };
    Button.prototype.componentDidMount = function () {
        if (this.props.forceLoading) {
            this.startLoading();
        }
    };
    Button.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.forceLoading !== this.props.forceLoading) {
            if (this.props.forceLoading) {
                this.startLoading();
            }
            else {
                this.stopLoading();
            }
        }
    };
    Button.prototype.render = function () {
        var loading = this.state.loading;
        var props = __assign(__assign({}, defaultButtonProps), this.props);
        var style = this.getStyle(props.intent);
        var body = loading ? React.createElement(TinyLoader, null) : props.children;
        var specialForceNoTooltip = !!props.disabled && props.disabled === RISK_BAD_UX_DISABLE_TOOLTIP;
        var renderWithTooltip = !specialForceNoTooltip && !!props.disabled;
        var realIntent = isCustomIntent(props.intent) ? 'custom' : props.intent;
        var cn = namespacedClassnames(buttonKey, realIntent, props.type, props.size, props.className, {
            loading: loading,
            disabled: !!props.disabled || loading,
            'has-tooltip': renderWithTooltip
        });
        var comp = (React.createElement("button", { ref: this.setRef, onClick: this.onClick, className: cn, disabled: !!props.disabled, style: style, "aria-label": props.ariaLabel }, body));
        return renderWithTooltip && !!props.disabled ? (React.createElement(Tooltip, { className: props.disabledTooltipClassName, body: props.disabled, align: 'left', relativeToBody: true, bodyWidth: props.disabledTooltipWidth, popperTargetClassName: props.tooltipPopperTargetClassName }, comp)) : comp;
    };
    return Button;
}(React.PureComponent));
export { Button };
//# sourceMappingURL=index.js.map